module.exports = __webpack_public_path__ + "img/no-leave.1f3482bd.png";